export default __webpack_public_path__ + "static/media/niko.46420ffd.jfif";